var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 36.1483H33.0433C31.51 36.1483 30.0533 36.7425 28.98 37.8158L25.7025 41.055C24.2075 42.5308 21.7733 42.5308 20.2783 41.055L17.0008 37.8158C15.9275 36.7425 14.4517 36.1483 12.9375 36.1483H11.5C8.31833 36.1483 5.75 33.5992 5.75 30.4559V9.54498C5.75 6.40165 8.31833 3.85254 11.5 3.85254H34.5C37.6817 3.85254 40.25 6.40165 40.25 9.54498V30.4559C40.25 33.58 37.6817 36.1483 34.5 36.1483Z",
    fill: "#ABD5F0",
    stroke: "#99CAFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5367 28.6732C23.2492 28.769 22.77 28.769 22.4633 28.6732C19.9717 27.8107 14.375 24.2649 14.375 18.2274C14.375 15.5632 16.5217 13.4165 19.1667 13.4165C20.7383 13.4165 22.1183 14.164 23 15.3332C23.8817 14.164 25.2617 13.4165 26.8333 13.4165C29.4783 13.4165 31.625 15.5632 31.625 18.2274C31.6058 24.2649 26.0283 27.8107 23.5367 28.6732Z",
    fill: "#D95656",
    stroke: "#D95656",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2ace66dbb5ca0462a20e2dbb257d6d75.svg";
export { ForwardRef as ReactComponent };